import React from 'react';
import { UNPAIRED_MESSAGE } from '../../../utils/tvPlayback';
import './UnpairedScreen.css';

// The TV's answer to a rejected device token: it never offers a password form.
const UnpairedScreen: React.FC = () => (
    <div className="unpaired-screen" role="status">
        <p>{UNPAIRED_MESSAGE}</p>
    </div>
);

export default UnpairedScreen;
